import React, { useEffect, useState, useRef } from 'react';
import { Modal, Tooltip, Input, Button } from 'antd';
import DataTable from 'react-data-table-component';
import { CSVLink } from 'react-csv';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import {
    USER_BLOCKED_LIST,
    USER_BLOCK_UNBLOCK,
    USER_BLOCK_LOG
} from  './../../../Utils/appConstants';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { ToastContainer, toast } from 'react-toastify';
import { getUser, kycStatusValue } from './../../../Utils/Common';
import { getUTCToLocalDateFormat } from './../../../Utils/function';

function BlockedUsers() {
    const user = getUser();
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;

    const [getData, setData]         = useState([]);
    const [getCsvData, setCsvData]   = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage]            = useState(1);
    const [isLimit, setLimit]        = useState(limit);
    const [search, setSearch]        = useState("");
    const [searchInput, setSearchInput] = useState("");

    // ---- Unblock modal ----
    const [isModalUnblock, setIsModalUnblock]       = useState(false);
    const [unblockUser, setUnblockUser]             = useState(null);
    const [unblockRemark, setUnblockRemark]         = useState("");
    const [unblockSaving, setUnblockSaving]         = useState(false);

    // ---- Log modal ----
    const [isModalLog, setIsModalLog]               = useState(false);
    const [logData, setLogData]                     = useState([]);
    const [logLoading, setLogLoading]               = useState(false);
    const [logUser, setLogUser]                     = useState(null);

    const columns = [
        {
            name: 'Action',
            cell: row => (
                <>
                    <div
                        className='icon-border border border-success text-success pointer'
                        onClick={() => handleOpenUnblock(row)}
                        title='Unblock User'
                    >
                        <i className="fa fa-unlock" aria-hidden="true"></i>
                    </div>
                    <div
                        className='icon-border border border-info text-info pointer'
                        onClick={() => handleOpenLog(row)}
                        title='View Block Log'
                    >
                        <i className="fa fa-history" aria-hidden="true"></i>
                    </div>
                </>
            ),
            width: "120px"
        },
        {
            name: 'User Id',
            selector: row => (
                <Tooltip placement="bottom" title={row.username}>
                    {row.username}
                </Tooltip>
            ),
            sortable: true,
            width: "130px"
        },
        {
            name: 'Name',
            selector: row => (
                <Tooltip placement="bottom" title={row.name}>
                    {row.name}
                </Tooltip>
            ),
            width: "150px"
        },
        {
            name: 'Mobile',
            selector: row => row.mobile || "—",
            width: "120px"
        },
        // {
        //     name: 'User Type',
        //     selector: row => row.roleDetails?.name || "—",
        //     width: "120px"
        // },
        {
            name: 'KYC',
            cell: row => <>{kycStatusValue(row.KYCStatus)}</>,
            width: "110px"
        },
        {
            name: 'Blocked At',
            cell: row => row.blockedAt
                ? getUTCToLocalDateFormat(row.blockedAt)
                : getUTCToLocalDateFormat(row.updatedAt),
            width: "140px"
        },
        {
            name: 'Blocked By',
            selector: row => row.blockedBy || "—",
            width: "130px"
        },
        {
            name: 'Remark',
            selector: row => (
                <Tooltip placement="bottom" title={row.blockRemark || "No remark recorded"}>
                    <span style={{ color: row.blockRemark ? '#1A1A2E' : '#9CA3AF' }}>
                        {row.blockRemark || "—"}
                    </span>
                </Tooltip>
            ),
            grow: 2
        }
    ];

    // ================== HANDLERS ==================

    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (newLimit) => {
        if (newLimit) {
            setLimit(newLimit);
            params.limit = newLimit;
        }
        if (search) params.search = search;

        const queryString = objectToQueryString(params);
        getRequest(`${USER_BLOCKED_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const getCSVDataList = () => {
        const csvParams = { page: 1, limit: 10000 };
        if (search) csvParams.search = search;

        const queryString = objectToQueryString(csvParams);
        getRequest(`${USER_BLOCKED_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                const csvdataRecord = [];
                const csvdata = response.data.docs || [];
                csvdata.forEach((e) => {
                    csvdataRecord.push({
                        "User Id": e.username,
                        "Name": e.name,
                        "Mobile": e.mobile || "",
                        "User Type": e.roleDetails?.name || "",
                        "KYC Status": kycStatusValue(e.KYCStatus),
                        "Blocked At": e.blockedAt ? getUTCToLocalDateFormat(e.blockedAt) : getUTCToLocalDateFormat(e.updatedAt),
                        "Blocked By": e.blockedBy || "",
                        "Remark": e.blockRemark || ""
                    });
                });
                setCsvData(csvdataRecord);
                setTimeout(() => csvLink.current.link.click(), 1000);
            } else {
                setCsvData([]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const handleSearch = () => {
        setSearch(searchInput);
        setPage(1);
    };

    const handleClear = () => {
        setSearch("");
        setSearchInput("");
        setPage(1);
    };

    const handlePageChange = page => setPage(page);

    // ---- Unblock ----
    const handleOpenUnblock = (row) => {
        if (!user.data || user.data.role.code !== "A") {
            toast.error("Only admin can unblock users");
            return;
        }
        setUnblockUser({
            userId: row._id,
            username: row.username,
            name: row.name
        });
        setUnblockRemark("");
        setIsModalUnblock(true);
    };

    const handleSubmitUnblock = () => {
        if (!unblockUser) return;
        if (!unblockRemark || !unblockRemark.trim()) {
            toast.error("Remark is required");
            return;
        }

        setUnblockSaving(true);
        const payload = {
            userId: unblockUser.userId,
            status: true,
            remark: unblockRemark.trim()
        };

        postRequest(`${USER_BLOCK_UNBLOCK}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                setIsModalUnblock(false);
                setUnblockUser(null);
                setUnblockRemark("");
                getDataReports();
            } else {
                toast.error(response.message);
            }
        }).catch(() => {
            toast.error("Failed to unblock user");
        }).finally(() => {
            setUnblockSaving(false);
        });
    };

    // ---- Log ----
    const handleOpenLog = (row) => {
        setLogUser({
            userId: row._id,
            username: row.username,
            name: row.name
        });
        setLogData([]);
        setIsModalLog(true);
        setLogLoading(true);

        getRequest(`${USER_BLOCK_LOG}?userId=${row._id}&page=1&limit=50`, history)
            .then((response) => {
                if (response.success === true && response.data) {
                    setLogData(response.data.docs || []);
                }
            })
            .catch(() => {})
            .finally(() => setLogLoading(false));
    };

    useEffect(() => {
        getDataReports();
    }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className="container-fluid pt-2 pb-5">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid mb-3 ml-2">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>
                                    Blocked <span className='text-red'>Users</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    {user.data.role.code === "A" &&
                        <div className='float-sm-right d-flex mb-1'>
                            <button
                                type="button"
                                className="btn btn-primary mr-3"
                                onClick={() => getCSVDataList()}
                            >
                                <i className="fa fa-file-excel"></i> Export
                            </button>
                            <CSVLink
                                data={getCsvData}
                                filename='blocked-users.csv'
                                className='hidden'
                                ref={csvLink}
                                target='_blank'
                            />
                        </div>}

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Input
                                placeholder="Search by username, name, or mobile"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onPressEnter={handleSearch}
                                allowClear
                            />
                        </div>
                        <div className="col-md-4">
                            <Button type="primary" onClick={handleSearch}>Search</Button>
                            <Button type="default" onClick={handleClear} className='ml-2'>Clear</Button>
                        </div>
                    </div>

                    <div className="box-body">
                        <DataTable
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            striped
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                            noDataComponent={
                                <div className='text-center text-muted py-4'>
                                    No blocked users found.
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                limit={2}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

            {/* --------- Unblock Modal --------- */}
            {isModalUnblock && unblockUser &&
                <Modal
                    title={
                        <span>
                            <i className="fa fa-unlock mr-2 text-success" />
                            Unblock User — {unblockUser.name} ({unblockUser.username})
                        </span>
                    }
                    width={520}
                    open={isModalUnblock}
                    onOk={handleSubmitUnblock}
                    onCancel={() => {
                        setIsModalUnblock(false);
                        setUnblockUser(null);
                        setUnblockRemark("");
                    }}
                    okText="Unblock"
                    cancelText="Cancel"
                    confirmLoading={unblockSaving}
                    okButtonProps={{
                        style: {
                            background: '#02A650',
                            borderColor: '#02A650',
                            fontWeight: 600
                        }
                    }}
                >
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <small className='text-muted'>
                                The user will be able to log in and transact again.
                            </small>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label>Remark <span className='text-danger'>*</span></label>
                            <textarea
                                className='form-control'
                                rows={3}
                                placeholder='Reason for unblocking (required)'
                                value={unblockRemark}
                                onChange={(e) => setUnblockRemark(e.target.value)}
                                style={{ borderRadius: 8, resize: 'none' }}
                            />
                            <small className='text-muted'>
                                This remark will be stored in the block log.
                            </small>
                        </div>
                    </div>
                </Modal>}

            {/* --------- Log Modal --------- */}
            {isModalLog && logUser &&
                <Modal
                    title={
                        <span>
                            <i className="fa fa-history mr-2 text-info" />
                            Block / Unblock History — {logUser.name} ({logUser.username})
                        </span>
                    }
                    width={720}
                    open={isModalLog}
                    onCancel={() => {
                        setIsModalLog(false);
                        setLogUser(null);
                        setLogData([]);
                    }}
                    footer={[
                        <button
                            key="close"
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                                setIsModalLog(false);
                                setLogUser(null);
                                setLogData([]);
                            }}
                        >
                            Close
                        </button>
                    ]}
                >
                    {logLoading ? (
                        <div className='text-center py-4'>Loading…</div>
                    ) : logData.length === 0 ? (
                        <div className='text-center text-muted py-4'>No log entries found.</div>
                    ) : (
                        <div style={{ maxHeight: 480, overflowY: 'auto' }}>
                            <table className='table table-sm table-bordered'>
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}>#</th>
                                        <th style={{ width: 110 }}>Action</th>
                                        <th style={{ width: 150 }}>Date</th>
                                        <th style={{ width: 150 }}>By</th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logData.map((log, i) => (
                                        <tr key={log._id || i}>
                                            <td>{i + 1}</td>
                                            <td>
                                                {log.action === 'block'
                                                    ? <span className='badge badge-danger'>Blocked</span>
                                                    : <span className='badge badge-success'>Unblocked</span>}
                                            </td>
                                            <td>{getUTCToLocalDateFormat(log.createdAt)}</td>
                                            <td>{log.actionByName || '—'}</td>
                                            <td>{log.remark}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal>}
        </div>
    );
}

export default BlockedUsers;